export default __webpack_public_path__ + "static/media/info_red.326fa40a.svg";